"use client";

import Image from "next/image";
import React, { useState } from "react";
import { ResourceGridProps } from "@/lib/Types";
import { Images } from "@assets/assets";
import WhitepaperDownloadPopup from "./WhitepaperDownloadPopup";
import { WhitepaperInterface } from "@/lib/Types";
import { formatDateMMDDYY } from "@/lib/Utility";

export const whitePaperDefault: WhitepaperInterface = {
  id: 0,
  title: "",
  slug: "",
  overview: "",
  category: "",
  pdf_file: null,
  thumb: null,
  created: "",
  modified: "",
  published_date: "",
  is_public: 0,
};

export default function ResourceGrid({ items, baseUrl }: ResourceGridProps) {
  const [selectedID, setSelectedID] = useState(whitePaperDefault);
  return (
    <>
      {selectedID?.id > 0 ? (
        <WhitepaperDownloadPopup
          whitePaper={selectedID}
          onClose={() => {
            setSelectedID(whitePaperDefault);
          }}
        />
      ) : null}

      <div className="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 xl:grid-cols-3">
        {items?.map((item: any, idx: number) => (
          <article
            key={idx}
            className="group flex h-full flex-col gap-[30px] border border-[#ecf0f6] bg-white p-[30px] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0px_24px_48px_rgba(23,55,97,0.1)]"
            onClick={() => {
              setSelectedID({
                ...item,
                baseUrl,
              });
            }}
          >
            <Image
              src={
                item?.thumb
                  ? `${baseUrl}${item.thumb}`
                  : Images?.imagePlaceholder
              }
              alt={item.title}
              className="object-cover transition-transform duration-500 group-hover:scale-[1.03]"
              priority={false}
              width={1000}
              height={270}
            />
            <div className="flex flex-col gap-[15px]">
              <span className="inline-flex w-fit items-center rounded-full border border-[#ecf0f6] bg-[#f4f7fb] px-5 py-2 text-[15px] font-medium text-[#00040b]">
                {item.category}
              </span>
              <h3 className="clash-font font-[500] text-[24px] leading-[140%] text-[#00040b] transition-colors duration-300 group-hover:text-[#225bd4]">
                {item.title}
              </h3>
              <span className="text-[15px] font-medium text-[#636363]">
                {formatDateMMDDYY(item.modified)}
              </span>
            </div>
          </article>
        ))}
      </div>
    </>
  );
}
